import React, { useState } from 'react';
import axios from 'axios';
import { API_URL, getUploadUrl } from '../../config/api';
import './css/ImageUpload.css';

const ImageUpload = ({ onUploadComplete, currentImage }) => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [preview, setPreview] = useState(currentImage || null);
  const [error, setError] = useState('');

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.match('image.*')) {
      setError('Please select an image file');
      return;
    }

    // Validate file size (10MB)
    if (file.size > 10 * 1024 * 1024) {
      setError('File size must be less than 10MB');
      return;
    }

    setError('');
    setUploading(true);
    setProgress(0);

    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setPreview(e.target.result);
    };
    reader.readAsDataURL(file);

    // Upload file
    const formData = new FormData();
    formData.append('image', file);

    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(`${API_URL}/api/upload/image`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        }
      });

      if (onUploadComplete) {
        onUploadComplete(response.data.filename);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Upload failed');
      setPreview(null);
    } finally {
      setUploading(false);
      setProgress(0);
    }
  };

  return (
    <div className="image-upload">
      <div className="image-preview-container">
        {preview ? (
          <div className="image-preview">
            <img src={preview.startsWith('data:') ? preview : (preview.startsWith('/') ? getUploadUrl(preview.slice(1)) : getUploadUrl(preview))} alt="Preview" />
            {uploading && (
              <div className="upload-overlay">
                <div className="progress-bar">
                  <div className="progress-fill" style={{ width: `${progress}%` }}></div>
                </div>
                <p className="progress-text">{progress}%</p>
              </div>
            )}
          </div>
        ) : (
          <div className="image-placeholder">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
            <p>No image selected</p>
          </div>
        )}
      </div>

      <div className="upload-controls">
        <label className="upload-btn" htmlFor="image-upload-input">
          {uploading ? 'Uploading...' : preview ? 'Change Image' : 'Upload Image'}
        </label>
        <input
          id="image-upload-input"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          disabled={uploading}
          style={{ display: 'none' }}
        />
      </div>

      {error && <div className="upload-error">{error}</div>}
    </div>
  );
};

export default ImageUpload;

